import React, { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const PaymentSuccess = () => {
  const location = useLocation();
  const [decryptedMsg, setDecryptedMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  const [paymentDetails, setPaymentDetails] = useState({
    payment_type: "Checking...",
    leadId: "N/A",
    loanNo: "N/A",
    loanAmount: "0.00",
    transactionDateTime: ""
  });

  // --- Encryption Keys ---
  const key = CryptoJS.enc.Utf8.parse("LxQY43Nc&87x8nxw");
  const iv = CryptoJS.enc.Utf8.parse("@@@@&&&&####$$$$");

  // --- Decoding & Decryption Logic ---
  const processData = (rawData) => {
    if (!rawData) return null;
    try {
      let decoded = rawData;
      while (decoded.includes("%")) {
        decoded = decodeURIComponent(decoded);
      }

      if (decoded.trim().startsWith("[") || decoded.trim().startsWith("{")) {
        return decoded;
      }

      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(decoded) },
        key,
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      );

      const result = decrypted.toString(CryptoJS.enc.Utf8);
      return result || null;
    } catch (e) {
      console.error("Processing Error:", e);
      return null;
    }
  };

  // --- Reloan Click Handler (Updated URL Format) ---
  const handleReloan = () => {
    const confirmAction = window.confirm("Are you sure you want to proceed for a Re-loan?");
    
    if (confirmAction) {
      try {
        // 1. Lead ID ko encrypt karna
        const encryptedLeadId = CryptoJS.AES.encrypt(
          paymentDetails.leadId, 
          key, 
          { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        ).toString();

        // 2. Base64 string ko URL safe banana (Special chars like / + = handle karne ke liye)
        const safeEncryptedId = encodeURIComponent(encryptedLeadId);
        
        // 3. Naya URL format: path ke end mein encrypted data
      const targetUrl = `https://dhanwalle.in/Api/TaskApi/leadid_copy?data=${safeEncryptedId}`;
        
        window.location.href = targetUrl;
        
      } catch (err) {
        alert("Something went wrong while processing reloan.");
      }
    } else {
      console.log("User opted out of reloan.");
    }
  };

  useEffect(() => {
    const handlePaymentResponse = () => {
      try {
        const params = new URLSearchParams(location.search);
        const responseParam = params.get("response");
        const respCodeParam = params.get("respcode");

        const now = new Date();
        const formattedDateTime = now.toLocaleString("en-GB", {
          day: "2-digit", month: "2-digit", year: "numeric",
          hour: "2-digit", minute: "2-digit", second: "2-digit",
          hour12: true,
        }).replace(",", "");

        let finalDetails = {
          payment_type: "PayTM",
          transactionDateTime: formattedDateTime,
          leadId: "N/A", loanNo: "N/A", loanAmount: "0.00"
        };

        let currentStatus = false;

        if (respCodeParam) {
          const processedResult = processData(respCodeParam);
          if (processedResult) {
            try {
              const jsonStartIndex = processedResult.indexOf("[") !== -1 ? processedResult.indexOf("[") : processedResult.indexOf("{");
              const cleanJson = jsonStartIndex !== -1 ? processedResult.substring(jsonStartIndex) : processedResult;

              const parsed = JSON.parse(cleanJson);
              const data = Array.isArray(parsed) ? parsed[0] : parsed;

              if (respCodeParam.includes("%") || !respCodeParam.startsWith("[")) {
                finalDetails.payment_type = "PayU";
              }

              currentStatus = (data.response_status === "TXN_SUCCESS" || data.status === "success" || data.response_status === "success");

              finalDetails = {
                ...finalDetails,
                leadId: data.lead_id || data.leadId || "N/A",
                loanNo: data.loan_no || data.loanNo || "N/A",
                loanAmount: data.loan_amount || data.loanAmount || "0.00",
              };
            } catch (e) { console.error("JSON Error", e); }
          }
        }

        if (responseParam) {
          const msgResult = processData(responseParam);
          if (msgResult) {
            let msg = msgResult.includes("RESPMSG=")
              ? msgResult.split("RESPMSG=")[1].split("|")[0]
              : msgResult;
            setDecryptedMsg(msg);
          }
        }

        setIsSuccess(currentStatus);
        setPaymentDetails(finalDetails);
      } catch (error) {
        setDecryptedMsg("Error loading payment details.");
      } finally {
        setLoading(false);
      }
    };
    handlePaymentResponse();
  }, [location]);

  if (loading) return <div style={styles.container}>Loading...</div>;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {isSuccess ? (
          <>
            <FaCheckCircle style={styles.iconSuccess} />
            <h2 style={styles.heading}>Payment Successful</h2>
            <p style={styles.text}>
              Great news! Your payment via <b>{paymentDetails.payment_type}</b> has been successfully processed.
            </p>
          </>
        ) : (
          <>
            <FaTimesCircle style={styles.iconFailure} />
            <h2 style={styles.heading}>Payment Failed</h2>
            <p style={{ ...styles.text, color: "#d9534f" }}>
              We couldn't process your <b>{paymentDetails.payment_type}</b> payment: {decryptedMsg || "Transaction Declined"}
            </p>
          </>
        )}

        <div style={styles.detailsBox}>
          <div style={styles.detailRow}><span>Lead ID:</span><strong>{paymentDetails.leadId}</strong></div>
          <div style={styles.detailRow}><span>Loan No:</span><strong>{paymentDetails.loanNo}</strong></div>
          <div style={styles.detailRow}><span>Amount:</span><strong>₹{paymentDetails.loanAmount}</strong></div>
          <div style={styles.detailRow}><span>Date & Time:</span><strong>{paymentDetails.transactionDateTime}</strong></div>
        </div>

        <div style={styles.divider}></div>

        {isSuccess ? (
          <button style={styles.buttonReloan} onClick={handleReloan}>
            Click Here for Reloan
          </button>
        ) : (
          <button style={styles.buttonHome} onClick={() => (window.location.href = "/")}>
            Go to Home
          </button>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: "85vh", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f4f7fb", padding: "20px" },
  card: { backgroundColor: "#fff", padding: "40px", borderRadius: "16px", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.1)", maxWidth: "480px", width: "100%" },
  iconSuccess: { fontSize: "70px", color: "#28a745", marginBottom: "20px" },
  iconFailure: { fontSize: "70px", color: "#dc3545", marginBottom: "20px" },
  heading: { fontSize: "26px", fontWeight: "700", marginBottom: "15px", color: "#333" },
  text: { fontSize: "16px", lineHeight: "1.6", color: "#555", marginBottom: "20px" },
  detailsBox: { backgroundColor: "#f9f9f9", padding: "20px", borderRadius: "12px", marginTop: "10px", textAlign: "left", border: "1px solid #eee" },
  detailRow: { display: "flex", justifyContent: "space-between", marginBottom: "10px", fontSize: "15px", color: "#444" },
  divider: { height: "1px", backgroundColor: "#eee", margin: "25px 0" },
  buttonReloan: { padding: "14px", border: "none", borderRadius: "8px", backgroundColor: "rgb(5, 48, 37)", color: "#fff", cursor: "pointer", fontSize: "16px", width: "100%", fontWeight: "600", transition: "0.3s" },
  buttonHome: { padding: "14px", border: "none", borderRadius: "8px", backgroundColor: "rgb(5, 48, 37)", color: "#fff", cursor: "pointer", fontSize: "16px", width: "100%", fontWeight: "600" },
};

export default PaymentSuccess;